'use client';
import React from 'react';
import store from '../../store';
import Otp from './otp/Otp';
import { useEffect, useState } from 'react';
import Expiry from './otp/Expiry';
import { Provider } from 'react-redux';
import image4 from '../../assests/images/Image 4.png';
import image5 from '../../assests/images/Image 5.png';
import styles from './Otp.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import { AppDispatch } from '../../store/index';
import { useDispatch } from 'react-redux';
import { getTokenStatus } from '../../slices/authSlice';
import Cookies from 'universal-cookie';

const ForgotPassword = (): React.JSX.Element => {
  const cookies = new Cookies(null, { path: '/' });
  const [jwtStatus, setjwtStatus] = useState(false);
  const [email, setEmail] = useState('');
  const { token } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const isOTP = cookies.get('otp');
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (!isOTP) {
  //     navigate('/');
  //   }
  // }, []);

  useEffect(() => {
    if (token) {
      const response = dispatch(getTokenStatus(token));
      response
        .unwrap()
        .then((originalPromiseResult: { data: { verify: boolean; email: string } }) => {
          if (originalPromiseResult.data.verify) {
            setjwtStatus(true);
            setEmail(originalPromiseResult.data.email);
          } else {
            setjwtStatus(false);
          }
        });
    }
  }, [token]);

  return (
    <Provider store={store}>
      <section className={styles.mainSection}>
        <div className={styles.backgroundLeft}>
          <img src={image4} alt="image54" />
        </div>
        <div className={styles.backgroundRight}>
          <img src={image5} alt="image5" />
        </div>
        <div className={styles.pageContainer}>
          <div className={styles.mainWrapper}>
            <div className={styles.userManagement}>
              <div className={styles.gridSection}>
                {jwtStatus ? <Otp email={email} token={token} /> : <Expiry />}
              </div>
            </div>
          </div>
        </div>
        {/* Backdrop */}
        {!jwtStatus && <div className={styles.modalBackdrop}></div>}
        {/* <Loader isLoading= {loading} /> */}
      </section>
    </Provider>
  );
};

export default ForgotPassword;
